const SET_IS_VERIFY = 'SET_IS_VERIFY'
const SET_IS_RESET = 'SET_IS_RESET'

const state = {
  isReset: '',
  isVerify:'',
}

const mutations = {
  [SET_IS_RESET]: (state, value) => {
    state.isReset = value
  },
  [SET_IS_VERIFY]: (state, value) => {
    state.isVerify = value
  }
}

const actions = {
  setIsReset({ commit }, val) {
    commit(SET_IS_RESET, val)
  },
  setIsVerify({ commit }, val) {
    commit(SET_IS_VERIFY, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
